
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.DriverHome = {

  template: ()=> {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Greenmile.Utils.getResourceWithUnitMetric('event.drivehome.distance'),
                  attributes: {
                    'class': 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'drive_home_distance_meters',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'text',
                    'name': 'drive_home_distance_meters',
                    maxlength: '10',
                    'alt': '',
                    value: '',
                    'size': '11',
                    id: 'drive_home_distance_meters',
                    class: 'modelAttribute textField numberPicker mandatory',
                    autocomplete: 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.drivehome.time'),
                  attributes: {
                    class: 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'drive_home_time_minutes',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    'type': 'text',
                    'name': 'drive_home_time_minutes',
                    'maxlength': '6',
                    alt: '',
                    value: '',
                    'size': '7',
                    'id': 'drive_home_time_minutes',
                    'class': 'modelAttribute textField numberPicker mandatory',
                    'autocomplete': 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    let value,
      formatedValue;

    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      if (Monet.Session.User.unitSystem !== 'METRIC') {
        value = new BigInt(jsonParam.distanceMeters) * 0.00062137;
        formatedValue = ((Math.round(value * 100)) / 100);
      } else {
        formatedValue = jsonParam.distanceMeters;
      }

      $('#drive_home_distance_meters').val(formatedValue);
      $('#drive_home_time_minutes').val(jsonParam.timeMinutes);
    }
  },
  retrieveParameter() {
    let distance,
      timeMinutes;

    if (Monet.Session.User.unitSystem !== 'METRIC') {
      distance = $('#drive_home_distance_meters').val() / 0.00062137;
    } else {
      distance = $('#drive_home_distance_meters').val();
    }

    distance = parseInt(distance, 10);
    timeMinutes = parseInt($('#drive_home_time_minutes').val(), 10);

    return JSON.stringify({
      distanceMeters: distance,
      timeMinutes,
    });
  },

};
